import {
  Announcement02Icon,
  CheckCircleIcon,
  InfoCircleIcon,
  InfoHexagonIcon,
  NotificationMessageIcon,
  ThumbsUpIcon,
  XCircleIcon,
} from '@systemeio/icons'
import { NotificationTypeEnum } from 'modules/profile/notification-settings/enums/notification-settings-enum'
import type { NotificationBaseItemInterface } from '../types/base-notification-interface'

export const getNotificationIcon = (notification: NotificationBaseItemInterface) => {
  switch (notification.eventType) {
    case NotificationTypeEnum.CommentOnCommunityPost:
    case NotificationTypeEnum.CommentReplyOnComment:
    case NotificationTypeEnum.CommentOnCourseCreatedByMe:
      return <NotificationMessageIcon className="text-icon-accent" />
    case NotificationTypeEnum.MentionInCommentOnCommunityPost:
    case NotificationTypeEnum.MentionInCommunityPost:
    case NotificationTypeEnum.CommunityNewPendingPost:
    case NotificationTypeEnum.CommunityPostIsPublished:
      return <Announcement02Icon className="text-icon-accent" />
    case NotificationTypeEnum.CommunityPostIsLiked:
    case NotificationTypeEnum.CommentIsLiked:
      return <ThumbsUpIcon className="text-icon-accent" />
    case NotificationTypeEnum.WithdrawalMethodOfAffiliateIsNotSet:
    case NotificationTypeEnum.ProfileInformationOfAffiliateIsNotFilled:
    case NotificationTypeEnum.DomainAuthenticationsNotValid:
    case NotificationTypeEnum.AffiliatePayoutFailed:
      return <InfoHexagonIcon className="text-icon-warning" />
    default:
      return <InfoCircleIcon className="text-icon-warning" />
  }
}

/** The state of a background job behind a notification, such as a workflow sharing or an export. */
export type JobNotificationStatus = 'running' | 'success' | 'failed' | 'cancelled'

export const getJobNotificationIcon = (status: JobNotificationStatus) => {
  switch (status) {
    case 'success':
      return <CheckCircleIcon className="text-icon-success" />
    case 'failed':
      return <XCircleIcon className="text-icon-error" />
    case 'cancelled':
      return <XCircleIcon className="text-icon-disabled" />
    default:
      return <InfoCircleIcon className="text-icon-warning" />
  }
}
